export enum DiscountCodeEnum {
    BOGO = "BOGO",
    BlueBenefits = "12EUR"
}
